import React from 'react';
import {observer, PropTypes as MobxPropTypes} from 'mobx-react';
import PropTypes from 'prop-types';

import inject from '../../../../../hoc/injectHoc';
import MediaPlayerPricingTabs from '../../../../../common/pricingTabs/MediaPlayerPricingTabs';
import {PAYMENT_PLAN_MONTHLY} from '../../../../../../constants/subscriptionPlanConstants';

/**
 * The MediaPlayerStep component.
 */
class MediaPlayerStep extends React.Component {
  /**
   * Purchase media players
   *
   * @param {'monthly' | 'lifetime'} frequency
   * @param {number} quantity
   */
  onPurchaseMediaPlayers = (frequency, quantity) => {
    const {purchaseFlowStore, nextStep} = this.props;

    purchaseFlowStore.setMediaPlayerPlan({
      frequency,
      quantity,
    });

    if (nextStep) {
      nextStep();
    }
  }

  /**
   * Renders the component.
   *
   * @returns {{}}
   */
  render() {
    const {purchaseFlowStore} = this.props;
    const {mediaPlayerPlan} = purchaseFlowStore;

    let tabSelected;
    if (mediaPlayerPlan) {
      tabSelected = mediaPlayerPlan.frequency === PAYMENT_PLAN_MONTHLY ? 'subscription' : 'lifetime';
    }

    return (
      <MediaPlayerPricingTabs
        onPurchase={this.onPurchaseMediaPlayers}
        user={purchaseFlowStore.currentUser}
        startingCreditCount={mediaPlayerPlan ? mediaPlayerPlan.quantity : undefined}
        tabSelected={tabSelected}
      />
    );
  }
}

MediaPlayerStep.propTypes = {
  nextStep: PropTypes.func,
  purchaseFlowStore: MobxPropTypes.observableObject,
};

MediaPlayerStep.wrappedComponent = {};
MediaPlayerStep.wrappedComponent.propTypes = {
  purchaseFlowStore: MobxPropTypes.observableObject.isRequired,
};

export default inject(MediaPlayerStep)(
  observer(MediaPlayerStep)
);
